import { Divider } from '@mui/material';

export default function MiniDivider() {
  return <Divider sx={{ width: '80%', margin: '10px 0' }} />;
}
